import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div
        data-testid="login-card"
        className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-xl shadow-slate-300/40 p-8 sm:p-10"
      >
        <img
          src="/aaywon-logo.png"
          alt="Aaywon Lamitubes & Packaging Solutions"
          className="h-14 w-auto object-contain mb-8"
        />
        <h1 className="font-display text-2xl font-bold text-slate-900 tracking-tight">
          Aaywon Lamitubes India
        </h1>
        <p className="text-slate-500 text-sm mt-1.5">Lead Funnel — sign in to continue</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label className="text-sm font-semibold text-slate-800">Email</Label>
            <Input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
              className="mt-1.5 h-11 bg-indigo-50/60 border-transparent focus-visible:border-slate-300 focus-visible:bg-white"
            />
          </div>
          <div>
            <Label className="text-sm font-semibold text-slate-800">Password</Label>
            <Input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1.5 h-11 bg-indigo-50/60 border-transparent focus-visible:border-slate-300 focus-visible:bg-white"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
              {error}
            </p>
          )}
          <Button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-semibold text-base"
          >
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>

        <p className="mt-6 text-xs text-slate-400 leading-relaxed">
          Accounts are created by an administrator. Contact your admin if you need access.
        </p>
      </div>
    </div>
  );
}
